import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { id_ID } from 'ng-zorro-antd/i18n';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-relief-importation-modal',
  templateUrl: './relief-importation-modal.component.html',
  styleUrls: ['./relief-importation-modal.component.less'],
  styles: [],
  standalone: false
})
export class ReliefImportationModalComponent implements AfterViewInit {
  // expose the footer template to the modal
  @ViewChild('footer', { static: true }) footerTemplate!: TemplateRef<any>;
  
  @Input() importedGoodsItems: any[] = [];

  _taxmonth: Date | null = null;
  @Input() get taxmonth() {
    return this._taxmonth;
  }
  set taxmonth(value: any) {
    this._taxmonth = value;
  }

  _tranxId: any | null = '';
  @Input() get tranxId() {
    return this._tranxId;
  }
  set tranxId(value: any | null) {
    this._tranxId = value;
  }

  @Input() hasReliefImportation: boolean = false;
  supplierId = 0;

  readonly #modal = inject(NzModalRef);

  loading = false;
  checkboxDisabled: boolean = false;
  disabled: boolean = false;
  editing: boolean = false;

  constructor(
    private modal: NzModalRef,
    private modalSrv: NzModalService,
    private fb: FormBuilder,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef,
    public msgSrv: NzMessageService
  ) {
    // Run after Angular finishes initial change detection
    Promise.resolve().then(() => {
      if (this.footerTemplate) {
        this.modal.updateConfig({
          nzFooter: this.footerTemplate
        });
      }
    });
  }

  form = this.fb.group({
    id: [<any>null, []],
    transactionId: [<any>null, []],
    sequenceNo: [{ value: 0, disabled: true }, []],
    taxMonth: [{ value: new Date(), disabled: true }, [Validators.required]],
    importEntryNo: [null, [Validators.required]],
    supplier: [<any>null, []],
    sellerName: [{ value: null, disabled: true }, []],
    sellerId: [0, []],
    releaseDate: [new Date(), []],
    importationDate: [new Date(), []],
    country: ['', []],
    vatRate: [<any>null, [Validators.required]],
    totalLandedCost: [0, [Validators.required]],
    dutiableValue: [0, []],
    chargesBeforeRelease: [{ value: 0, disabled: true }, []],
    exempt: [0, []],
    taxableGoods: [{ value: 0, disabled: true }, []],
    orNumber: ['', [Validators.required]],
    dateOfVATPayment: [new Date(), [Validators.required]],
    vat: [0,  [Validators.required]],
    importedGoodsItemList: [<any>null, []],
    details: this.fb.array([this.createLine()]),
    srpnciPostingId: [<any>null, []]
  });

  createLine() {
    const form = this.fb.group({
      docType: [<any>null, []],
      docId: [<any>null, []]
    });
    return form;
  }

  buildDetailLines(data: any[], fromLoadData: boolean) {
    //set value on relief importation details
    this.form.controls.details.clear();
    if (data?.length > 0) {
      if (fromLoadData) {
        data.forEach(item => {
          const row = this.createLine();
          row.controls.docId.setValue(item.docId);
          row.controls.docType.setValue(item.docType);
          this.form.controls.details.push(row);
        });
      } else {
        data.forEach(item => {
          const row = this.createLine();
          row.controls.docId.setValue(item.id);
          row.controls.docType.setValue(item.docType);
          this.form.controls.details.push(row);
        });
      }
    }
  }

  ngAfterViewInit(): void {
    this.loading = true;
    if (!this.editing) {
      this.form.disable();
    }
    else {
      this.form.controls.importEntryNo.enable();
      this.form.controls.supplier.enable();
      this.form.controls.releaseDate.enable();
      this.form.controls.importationDate.enable();
      this.form.controls.country.enable();
      this.form.controls.vatRate.enable();
      this.form.controls.totalLandedCost.enable();
      this.form.controls.dutiableValue.enable();
      this.form.controls.exempt.enable();
      this.form.controls.orNumber.enable();
      this.form.controls.dateOfVATPayment.enable();
      this.form.controls.vat.enable();
    }
    this.loadData();
  }

  loadData() {
    this.http
      .get('api/reliefImportations/getRecord', { tranxId: this.tranxId })
      .subscribe(res => {
        if (res?.sellerId > 0 && this.hasReliefImportation) {
          this.form.patchValue(res);
          this.buildDetailLines(res.details, true);
          if (res.importedGoodsItemList.length > 0) {
            this.disabled = true;
            this.checkboxDisabled = true;
            this.importedGoodsItems = res.importedGoodsItemList;
          }
        } else if (res?.sellerId === 0 && this.form.controls.sellerId.value) {
          //this is for modal reopen and not save yet
          this.inquire();
        }else {
          this.form.controls.sequenceNo.setValue(res?.sequenceNo);
        }

        this.form.controls.taxMonth.setValue(this.taxmonth);
        this.form.controls.srpnciPostingId.setValue(res.srpnciPostingId);
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  inquire() {
    this.loading = true;
    var supplierId = this.form.controls.sellerId.value;

    this.http
      .get('api/reliefImportations/inquireImportedGoodsItem', {
        supplierId: supplierId
      })
      .subscribe(res => {
        if (res !== null) {
          this.importedGoodsItems = res;
          this.cdr.detectChanges();
        }

        //this is for modal reopen and not save yet
        const details = this.form.controls.details.value.filter(x => x.docId != null && x.docId !== 0);
        if (details.length > 0) {
          this.importedGoodsItems = this.importedGoodsItems.filter(item => details.map(x => x.docId).includes(item.id));
          this.importedGoodsItems.forEach(item => {item.isCheck = true;})
          this.checkboxDisabled = true;
          this.cdr.detectChanges();
        }
        this.loading = false;
      });
  }

  supplierChange(val: any) {
    this.form.controls.sellerId.setValue(val.id);
    this.form.controls.sellerName.setValue(val.name);
    this.supplierId = val.id ?? 0;
    this.cdr.detectChanges();
  }

  check(check: any, line: any) {
    line.isCheck = check;
    let total = this.form.controls.totalLandedCost.value ?? 0;
    if (check) {
      total += line.netAmountLocal;
    } else {
      total = total === 0 ? 0 : total - line.netAmountLocal;
    }
    this.form.controls.totalLandedCost.setValue(total);

    //set value on relief importation details
    const checkedLines = this.importedGoodsItems.filter(d => d.isCheck);
    this.buildDetailLines(checkedLines, false);

    this.cdr.detectChanges();
  }

  recalculate(field: string, val: any) {
    //field value is base on the field that had changes
    if (field === 'totalLandedCost') {
      this.form.controls.dutiableValue.setValue(val);

      var exempt = this.form.controls.exempt.value ?? 0;
      this.form.controls.taxableGoods.setValue(val - exempt);

      var vatrate = this.form.controls.vatRate.value;
      if (vatrate) {
        var rate = vatrate === 10 ? 0.1 : 0.12;
        this.form.controls.vat.setValue(val * rate);
      }

      var dutiable = this.form.controls.dutiableValue.value ?? 0;
      this.form.controls.chargesBeforeRelease.setValue(val - dutiable);
    }

    var totalLandedCost = this.form.controls.totalLandedCost.value ?? 0;
    if (field === 'dutiable') {
      this.form.controls.chargesBeforeRelease.setValue(totalLandedCost - val);
    }

    var taxableGoods = this.form.controls.taxableGoods.value ?? 0;
    if (field === 'vatrate') {
      if (val) {
        var rate = val === 10 ? 0.1 : 0.12;
        this.form.controls.vat.setValue(taxableGoods * rate);
      }
    }

    if (field === 'exempt') {
      var totalLandedCost = this.form.controls.totalLandedCost.value ?? 0;
      taxableGoods = totalLandedCost - val;
      this.form.controls.taxableGoods.setValue(taxableGoods);

      var vatrate = this.form.controls.vatRate.value;
      if (vatrate) {
        var rate = vatrate === 10 ? 0.1 : 0.12;
        this.form.controls.vat.setValue(taxableGoods * rate);
      }
    }
  }

  okbtn() {
    if (this.form.invalid) {
      this.form.markAllAsTouched(); // highlight errors
      this.msgSrv.error('Please complete all required fields.');
      return;
    }

    var taxfulldate = this.form.controls.taxMonth.value ?? new Date();
    var releaseDate = this.form.controls.releaseDate.value ? new Date(this.form.controls.releaseDate.value) : null;

    if (releaseDate) {
      if (releaseDate > taxfulldate) {
        this.msgSrv.error('Assesment Date is invalid!');
        return;
      }
    }

    var starttaxMonth = new Date( taxfulldate?.getFullYear(), taxfulldate?.getMonth(), 1 );
    if ((releaseDate && releaseDate < starttaxMonth) || releaseDate === null) {
      this.modalSrv.info({
        nzTitle: 'BIR System Message',
        nzWidth: '500px',
        nzContent: `Reminder: The current Tax Month you are encoding is: ${starttaxMonth.toLocaleString('en', { month: 'long' })}, ${starttaxMonth.getFullYear()}.
                    You may have typed a wrong date in the field Assesment Date.`,
        nzOnOk: () => {
          const details = this.form.controls.details.value.filter(x => x.docId != null && x.docId !== 0)
          this.#modal.destroy(details.length);
        }
      });

      return;
    }

    var vatPaymentDate = this.form.controls.dateOfVATPayment.value ? new Date(this.form.controls.dateOfVATPayment.value) : null;
    if (vatPaymentDate) {
      if (vatPaymentDate > taxfulldate) {
        this.msgSrv.error('Vat Payment Date is invalid!');
        return;
      }
    }

    if ((vatPaymentDate && vatPaymentDate < starttaxMonth) || vatPaymentDate === null) {
      this.modalSrv.info({
        nzTitle: 'BIR System Message',
        nzWidth: '500px',
        nzContent: `Reminder: The current Tax Month you are encoding is: ${starttaxMonth.toLocaleString('en', { month: 'long' })}, ${starttaxMonth.getFullYear()}.
                    You may have typed a wrong date in the field date of VAT Payment.`,
        nzOnOk: () => {
          const details = this.form.controls.details.value.filter(x => x.docId != null && x.docId !== 0)
          this.#modal.destroy(details.length);
        }
      });

      return;
    }

    var dutiableValue = this.form.controls.dutiableValue.value ?? 0;
    var totalLandedCost = this.form.controls.totalLandedCost.value ?? 0;
    if (dutiableValue > totalLandedCost) {
      this.msgSrv.error(
        'Dutiable Value cannot be greater than Total Landed Cost.'
      );
      return;
    }

    var exemptValue = this.form.controls.exempt.value ?? 0;
    if (exemptValue > totalLandedCost) {
      this.msgSrv.error(
        'Exempt cannot be greater than the Total Landed Cost.'
      );
      return;
    }

    const details = this.form.controls.details.value.filter(x => x.docId != null && x.docId !== 0)
    this.#modal.destroy(details.length);
  }

  untagBtn() : void {
    this.modalSrv.confirm({
      nzTitle: 'Untag as Imported Goods',
      nzContent: 'This will remove all the inputted Relief Importation Details. This action cannot be undone.',
      nzOnOk: () => {
        this.importedGoodsItems.forEach(o => {o.isCheck = false});
        
        //get current postingId and seq value
        const srpnciPostingId = this.form.controls.srpnciPostingId.value;
        const currentSeq = this.form.controls.sequenceNo.value;

        this.form.controls.details.clear();
        this.form.reset();
        this.form.controls.sequenceNo.setValue(currentSeq);
        this.form.controls.taxMonth.setValue(this.taxmonth);
        this.form.controls.srpnciPostingId.setValue(srpnciPostingId);
        this.checkboxDisabled = false;
        this.disabled = false;
        this.hasReliefImportation = false;
        this.cdr.detectChanges();
      }
    });
  }

  cancelBtn() : void {
    // const details = this.form.controls.details.value.filter(x => x.docId != null && x.docId !== 0)
    this.#modal.destroy();
  }
}
